import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ApiService } from '../services/api.service';
import { ModalController} from '@ionic/angular';

import { Business } from '../models/business';

import { BusinessCreatePage } from '../business-create/business-create.page';

@Component({
  selector: 'app-business-selector',
  templateUrl: './business-selector.component.html',
  styleUrls: ['./business-selector.component.scss'],
})
export class BusinessSelectorComponent implements OnInit {

  businessData: Business[];
  loading: boolean = true;

  constructor(public modalCtrl: ModalController, public apiService: ApiService) { }

  ngOnInit() {}

  ionViewWillEnter() {
    // Used ionViewWillEnter as ngOnInit is not 
    // called due to view persistence in Ionic
    this.getAllBusinesses();
  }

  getAllBusinesses() {
    // Get API list of contacts
    this.apiService.getBusinessList().subscribe(response => {

      this.businessData = response;
      this.loading = false;

    })
  }

  async showNewBusinessModal() {  
    const modal = await this.modalCtrl.create({  
      component: BusinessCreatePage  
    });

    modal.onDidDismiss()
      .then((data) => {

        const business = data.data;

        if (business != null) {
          // TODO: Toast notification
          //this.presentToast('A new Business was created.');

          // Refresh data
          this.getAllBusinesses();
        }
        else {
          // User has dismissed creating a new business without saving
        }
    });

    await modal.present();
  }

  dismiss() {  
    return this.modalCtrl.dismiss();
  }

  chooseBusiness(business) {
    return this.modalCtrl.dismiss(business, 'confirm');
  }

}
